import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolder2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFolder2"><Path d="M9.88889 3.5H2.5V19.5H21.5V5.5H12L9.88889 3.5Z" stroke="currentColor"/><Path d="M2.5 12.5V9.5H21.5V12.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconFolder2;
